import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fa54b66"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "svg-inline",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12.5",
  cy: "12.5",
  r: "12.5",
  fill: "#c6243e"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11.375 8.67969C11.375 8.05625 11.8766 7.55469 12.5 7.55469C13.1234 7.55469 13.625 8.05625 13.625 8.67969V13.9297C13.625 14.5531 13.1234 15.0547 12.5 15.0547C11.8766 15.0547 11.375 14.5531 11.375 13.9297V8.67969Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12.5",
  cy: "18.0547",
  r: "1.5",
  fill: "currentColor"
}, null, -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}